import axios from '../../app/api/axios';
import {getCache, setCache} from '../../app/api/cache';
import {
    // Taxonomies
    GET_SCHOOLS_TYPES,
    GET_SCHOOLS_PROGRAMMES,
    GET_SCHOOLS_DEGREES,
    GET_SCHOOLS_CERTIFICATIONS,
    TAXONOMIES_LOADING,

    // Schools dropdown
    GET_SCHOOLS_DROPDOWN_REQUEST,
    GET_SCHOOLS_DROPDOWN_FAILURE,
    GET_SCHOOLS_DROPDOWN_SUCCESS,

    // Schools Google Maps
    GET_SCHOOLS_MAPS_REQUEST,
    GET_SCHOOLS_MAPS_FAILURE,
    GET_SCHOOLS_MAPS_SUCCESS,

    // Schools list
    GET_SCHOOLS_REQUEST,
    GET_SCHOOLS_FAILURE,
    GET_SCHOOLS_SUCCESS,
    SET_SCHOOLS_SEARCH_CRITERIA,
    RESET_SCHOOLS_SEARCH_CRITERIA,
    TOGGLE_DRAWER_MOBILE_FILTER_SEARCH,

    // School details
    GET_SCHOOL_REQUEST,
    GET_SCHOOL_FAILURE,
    GET_SCHOOL_SUCCESS,
    
    // Dashboard
    DASHBOARD_GET_SCHOOLS_AUTHOR,
    DASHBOARD_GET_SCHOOLS_LOADING,

    // UI
    UI_SET_SCHOOL_FOCUSED,
    UI_REMEMBER_SCROLL_POSITION_LISTING,
    UI_REMEMBER_PAGINATION_LISTING,
} from "./types"

/**
 * Get a list of schools.
 *
 * @param {number} page                     Pagination
 * @param {boolean} pageWithPreviousResults If false, returns only the results for the given requested page. If true, returns the results for the previous page and the requested page.
 * @param {boolean} newSearch
 * @param {number} type                     ID of the term
 * @param {number} programme                ID of the term
 * @param {number} degree                   ID of the term
 */
export const getSchools = (page = 1, pageWithPreviousResults = false, newSearch = false, type = 0, programme = 0, degree = 0, fromUserAction = true) => dispatch => {
    dispatch(setSchoolsLoading());

    const minLoadingTime = 0;
    let startTime = new Date().getTime();

    axios
        .post('agep/v1/schools', {
            page: page,
            pageWithPreviousResults: pageWithPreviousResults,
            type: type,
            programme: programme,
            degree: degree,
        })
        .then(function(res) {
            let fakeLoadingTime = 0;
            let requestTime = new Date().getTime() - startTime;

            if (requestTime < minLoadingTime) {
                fakeLoadingTime = minLoadingTime - requestTime;
            }

            setTimeout(() => {
                dispatch({
                    type: GET_SCHOOLS_SUCCESS,
                    payload: res.data,
                    page: page,
                    newSearch: newSearch,
                    fakeLoadingTime: fakeLoadingTime,
                    search: {
                        type: type,
                        programme: programme,
                        degree: degree,
                    }
                });
            }, fakeLoadingTime);
        })
        .catch(function (err) {
            const data = (err.response.hasOwnProperty('data')) ? err.response.data : null;

            dispatch({
                type: GET_SCHOOLS_FAILURE,
                payload: data
            });
        });
};

/**
 * Get a dropdown (list with "id" and "title") of schools.
 */
export const getSchoolsDropdown = () => dispatch => {
    dispatch(setSchoolsDropdownLoading());

    const cacheKey = 'api_get_schools_dropdown';
    const cached = getCache(cacheKey);

    if (cached) {
        dispatch({
            type: GET_SCHOOLS_DROPDOWN_SUCCESS,
            payload: cached
        });
    } else {
        axios
            .get('agep/v1/schools_dropdown')
            .then(res => {
                dispatch({
                    type: GET_SCHOOLS_DROPDOWN_SUCCESS,
                    payload: res.data
                });

                setCache(cacheKey, res.data);
            })
            .catch(err =>
                dispatch({
                    type: GET_SCHOOLS_DROPDOWN_FAILURE,
                    payload: err.response.data
                })
            );
    }
};

/**
 * Get a list of schools for the Gooel Maps.
 */
export const getSchoolsMaps = (type = 0, programme = 0, degree = 0) => dispatch => {
    dispatch(setSchoolsMapsLoading());

    axios
        .post('agep/v1/schools_maps', {
            type: type,
            programme: programme,
            degree: degree,
        })
        .then(res =>
            dispatch({
                type: GET_SCHOOLS_MAPS_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_SCHOOLS_MAPS_FAILURE,
                payload: err.response.data
            })
        );
};

/**
 * Get the details of a given school.
 *
 * @param {string} slug
 */
export const getSchool = (slug) => dispatch => {
    dispatch(setSchoolLoading());

    axios
        .get('agep/v1/school/' + slug)
        .then(res =>
            dispatch({
                type: GET_SCHOOL_SUCCESS,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_SCHOOL_FAILURE,
                payload: err.response
            })
        );
};

export const getSchoolsTypes = () => dispatch => {
    dispatch(setTaxonomiesLoading());

    const cacheKey = 'api_get_schools_taxonomy_type';
    const cached = getCache(cacheKey);

    if (cached) {
        dispatch({
            type: GET_SCHOOLS_TYPES,
            payload: cached
        });
    } else {
        axios
            .get('agep/v1/schools/taxonomy/type')
            .then(res => {
                dispatch({
                    type: GET_SCHOOLS_TYPES,
                    payload: res.data
                });

                setCache(cacheKey, res.data);
            })
            .catch(err =>
                dispatch({
                    type: GET_SCHOOLS_TYPES,
                    payload: null
                })
            );
    }
};

export const getSchoolsProgrammes = () => dispatch => {
    dispatch(setTaxonomiesLoading());

    const cacheKey = 'api_get_schools_taxonomy_programmes';
    const cached = getCache(cacheKey);

    if (cached) {
        dispatch({
            type: GET_SCHOOLS_PROGRAMMES,
            payload: cached
        });
    } else {
        axios
            .get('agep/v1/schools/taxonomy/programme')
            .then(res => {
                dispatch({
                    type: GET_SCHOOLS_PROGRAMMES,
                    payload: res.data
                });

                setCache(cacheKey, res.data);
            })
            .catch(err =>
                dispatch({
                    type: GET_SCHOOLS_PROGRAMMES,
                    payload: null
                })
            );
    }
};

export const getSchoolsCertifications = () => dispatch => {
    dispatch(setTaxonomiesLoading());

    const cacheKey = 'api_get_schools_taxonomy_certifications';
    const cached = getCache(cacheKey);

    if (cached) {
        dispatch({
            type: GET_SCHOOLS_CERTIFICATIONS,
            payload: cached
        });
    } else {
        axios
            .get('agep/v1/schools/taxonomy/certifications')
            .then(res => {
                dispatch({
                    type: GET_SCHOOLS_CERTIFICATIONS,
                    payload: res.data
                });

                setCache(cacheKey, res.data);
            })
            .catch(err =>
                dispatch({
                    type: GET_SCHOOLS_CERTIFICATIONS,
                    payload: null
                })
            );
    }
};

export const getSchoolsDegrees = () => dispatch => {
    dispatch(setTaxonomiesLoading());

    const cacheKey = 'api_get_schools_taxonomy_degree';
    const cached = getCache(cacheKey);

    if (cached) {
        dispatch({
            type: GET_SCHOOLS_DEGREES,
            payload: cached
        });
    } else {
        axios
            .get('agep/v1/schools/taxonomy/degree')
            .then(res => {
                dispatch({
                    type: GET_SCHOOLS_DEGREES,
                    payload: res.data
                });

                setCache(cacheKey, res.data);
            })
            .catch(err =>
                dispatch({
                    type: GET_SCHOOLS_DEGREES,
                    payload: null
                })
            );
    }
};

export const setSchoolsSearchCriteria = (type = 0, programme = 0, degree = 0) => dispatch => {
    dispatch({
        type: SET_SCHOOLS_SEARCH_CRITERIA,
        searchTaxonomyType: type,
        searchTaxonomyProgramme: programme,
        searchTaxonomyDegree: degree,
    })
};

export const resetSchoolsSearchCriteria = (type = 0, programme = 0, degree = 0) => dispatch => {
    dispatch({
        type: RESET_SCHOOLS_SEARCH_CRITERIA,
        searchTaxonomyType: type,
        searchTaxonomyProgramme: programme,
        searchTaxonomyDegree: degree,
    })
};

export const setUiSchoolFocused = id => {
    return {
        type: UI_SET_SCHOOL_FOCUSED,
        payload: id,
    };
};

export const rememberScrollPositionListing = position => {
    return {
        type: UI_REMEMBER_SCROLL_POSITION_LISTING,
        payload: position,
    };
};

export const rememberPaginationListing = page => {
    return {
        type: UI_REMEMBER_PAGINATION_LISTING,
        payload: page,
    };
};

export const dashboardGetSchoolsAuthor = (page = 1, newSearch = false) => dispatch => {
    dispatch(setDashboardSchoolsLoading());

    const minLoadingTime = 0;
    let startTime = new Date().getTime();

    axios
        .post('agep/v1/schools_user_author', {
            page: page
        })
        .then(function(res) {
            let fakeLoadingTime = 0;
            let requestTime = new Date().getTime() - startTime;

            if (requestTime < minLoadingTime) {
                fakeLoadingTime = minLoadingTime - requestTime;
            }

            setTimeout(() => {
                dispatch({
                    type: DASHBOARD_GET_SCHOOLS_AUTHOR,
                    payload: res.data,
                    page: page,
                    newSearch: newSearch,
                    fakeLoadingTime: fakeLoadingTime
                });
            }, fakeLoadingTime);
        })
        .catch(err =>
            dispatch({
                type: DASHBOARD_GET_SCHOOLS_AUTHOR,
                payload: null
            })
        );
};

export const toggleDrawerMobileFilterSearch = () => dispatch => {
    dispatch({
        type: TOGGLE_DRAWER_MOBILE_FILTER_SEARCH
    })
};

export const setDashboardSchoolsLoading = () => {
    return {
        type: DASHBOARD_GET_SCHOOLS_LOADING
    };
};

export const setSchoolLoading = () => {
    return {
        type: GET_SCHOOL_REQUEST
    };
};

export const setSchoolsLoading = () => {
    return {
        type: GET_SCHOOLS_REQUEST
    };
};

export const setTaxonomiesLoading = () => {
    return {
        type: TAXONOMIES_LOADING
    };
};

export const setSchoolsDropdownLoading = () => {
    return {
        type: GET_SCHOOLS_DROPDOWN_REQUEST
    };
};

export const setSchoolsMapsLoading = () => {
    return {
        type: GET_SCHOOLS_MAPS_REQUEST
    };
};



// WEBPACK FOOTER //
// ./src/features/Schools/actions.js